import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { disableEnableScroll } from "@tw/style-guide/lib/components/utilities/util";
import PopupConfirm from "../popupConfirm/popupConfirm";
import Share from "../share/share";
import { useDispatch, useSelector } from "react-redux";
import Breakpoint from "@tw/style-guide/lib/components/utilities/breakpoint";
import { fetchTermsConditionsState } from "../../redux/reducers";
import { getLocalStorage } from "../../utils/helper";
import axios from "../../utils/axios_interceptor"
import { getAcApiUrl } from "../../utils/helper";
import { CircularProgress } from "@mui/material";
import { getAccessHeader, getADA, getRole } from "../../utils/loginSession";

const ShareBar = (props) => {
  const [breakpoint, setBreakpoint] = useState("xs");
  let isDesktop = breakpoint !== "xs" && breakpoint !== "sm";
  const dispatch = useDispatch();
  const {
    showPopup,
    title,
    shareInfo,
    is3e,
    url,
    onClosePopup,
    successShareCallBack,
    setShowShareBar,
    product,
    search_keyword
  } = props;
  const [tnCCheck, setTnCCheck] = useState(false);
  const [tnCAgreed, setTnCAgreed] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [isEnabled, setIsEnabled] = useState(getLocalStorage("sopDetail"));


  const getState = useSelector((state) => state || {});
  let login = {
    accessHeader: getAccessHeader(getState),
    ada: getADA(getState),
    role: getRole(getState),
  };


  let termsConditions = getLocalStorage("sharebarTNC"); //Get T&C from local storage
  let userAgreed = getLocalStorage("sharebarTNCAgreed"); //Get T&C agreed

  useEffect(() => {
    if (Object.keys(termsConditions).length == 0) {
      //empty object
      //if not in local storage, retrieve from API
      dispatch(fetchTermsConditionsState());
    }
  }, [Object.keys(termsConditions).length]);

  useEffect(() => {
    if (userAgreed && userAgreed === "true") {
      setTnCAgreed(true);
      setShowShare(true);
    }
  }, [userAgreed]);

  useEffect(() => {
    if (showPopup) disableEnableScroll(true);
    return () => {
      disableEnableScroll(false);
    };
  }, [showPopup]);

  const onBackdropClick = () => {
    setShowShareBar(false);
    if (onClosePopup !== undefined) onClosePopup();
  };
  const onSuccessShare = () => {
    if (successShareCallBack !== undefined) successShareCallBack();
  };
  const refreshPage = () => {
    onBackdropClick();
    if (typeof window !== "undefined") {
      window.location.href = "/login?exp=aa&h=" + btoa(window.location.pathname);
    }
  }

  const agreeTnC = async () => {
    setIsLoading(true);

    //Handle already agreed before page refresh
    const apiUrl = getAcApiUrl();
    const resAgreed = await axios({
      headers: login.accessHeader,
      method: 'post',
      url: `${apiUrl}/getShareBarAgreedPolicy`,
      data: {
        loginAda: login.ada,
        "policyVersion": String(termsConditions._version)
      }
    });

    let agreed = resAgreed.data;

    if (!agreed && agreed !== true) {
      const res = await axios({
        headers: login.accessHeader,
        method: "post",
        url: `${apiUrl}/addShareBarAgreedPolicy`,
        data: {
          loginAda: login.ada,
          policyVersion: String(termsConditions._version),
        },
      });

      if (res.data) {
        setIsLoading(false);
        setTnCAgreed(true);
        setTnCCheck(true);
        localStorage.setItem("sharebarTNCAgreed", true);
      }
    }
    else {
      localStorage.setItem("sharebarTNCAgreed", agreed);
      setIsLoading(false);
      setTnCAgreed(true);
      setTnCCheck(true);
    }
  };
  const agreeShare = () => {
    setTnCCheck(true);
    setShowShare(true);
  };
  return (
    <>
      {showPopup && login.ada !== "" && (
        <div>
          <PopupConfirm
            title={termsConditions.sub_title}
            titleLine={true}
            showPopup={!tnCAgreed && !tnCCheck}
            okBtn={{
              text: "我同意",
              action: agreeTnC,
            }}
            cancelBtn={{
              text: "",
              action: onBackdropClick,
            }}
          >
            {!isLoading && isDesktop && (
              <div
                dangerouslySetInnerHTML={{ __html: termsConditions.pc_text_1 }}
              />
            )}
            {!isLoading && !isDesktop && (
              <div
                dangerouslySetInnerHTML={{
                  __html: termsConditions.mobile_text_1,
                }}
              />
            )}
            {isLoading && (
              <center>
                <CircularProgress />
              </center>
            )}
          </PopupConfirm>

          <PopupConfirm
            title={termsConditions.sub_title}
            titleLine={true}
            showPopup={tnCAgreed && tnCCheck && !showShare}
            okBtn={{
              text: "立即分享",
              action: agreeShare,
            }}
            cancelBtn={{
              text: "",
              action: onBackdropClick,
            }}
          >
            {isDesktop && (
              <div
                dangerouslySetInnerHTML={{ __html: termsConditions.pc_text_2 }}
              />
            )}
            {!isDesktop && (
              <div
                dangerouslySetInnerHTML={{
                  __html: termsConditions.mobile_text_2,
                }}
              />
            )}
          </PopupConfirm>

          <Share
            title={title}
            url={url}
            shareInfo={shareInfo}
            userRole={login.role}
            is3e={is3e}
            callBack={onBackdropClick}
            successShareCallBack={onSuccessShare}
            showPopup={showShare}
            enabled={termsConditions.share_enabled}
            product={product}
            search_keyword={search_keyword}
          />
          <Breakpoint onBreakpointChange={setBreakpoint} />
        </div>
      )}
      {showPopup && login.ada == "" &&
        <PopupConfirm
          title="請登錄"
          titleLine={true}
          showPopup={login.ada === ''}
          okBtn={{
            text: "確定",
            action: refreshPage,
          }}
          cancelBtn={{
            text: "",
            action: refreshPage,
          }}
        >
          您目前未登錄
        </PopupConfirm>
      }
    </>
  );
};

ShareBar.defaultProps = {
  title: "分享至",
  url: "",
  shareInfo: {
    type: "", // product/category/promotions/bundle
    id: "",
  },
  is3e: false,
  showPopup: false,
  // tncMsg1: "我同意遵守安利公司社群商務經營規範。",
  // tncMsg2: "恭喜您已開通！"
};

ShareBar.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  shareInfo: PropTypes.object,
  is3e: PropTypes.bool,
  onClosePopup: PropTypes.func,
  successShareCallBack: PropTypes.func,
  showPopup: PropTypes.bool,
  setShowShareBar: PropTypes.func,
  accessHeader: PropTypes.string,
  loginAda: PropTypes.string,
};

export default ShareBar;
